import React, {useContext} from 'react';
import {Context} from '../../index';
import Container from '../../components/ui/Container';
import Breadcrumbs from '../../components/Breadcrumbs/Breadcrumbs';
import Seo from '../../components/ui/Seo';
import {CONTACTS} from '../../data/siteData';
import vkLogo from '../../images/vk-logo.svg';
import styles from './Contacts.module.css';

const Contacts = () => {
    const {global} = useContext(Context);
    global.setIsAdminPage(false);

    return (
        <Container className={styles.page}>
            <Seo
                title="Контакты — 4 Цвета"
                description="Адрес, телефон, email и карта проезда полиграфической компании 4 Цвета в Томске."
            />
            <Breadcrumbs items={[{label: 'Контакты'}]}/>

            <h1 className={styles.title}>Контакты</h1>

            <section className={styles.layout}>
                <address className={styles.contacts} aria-label="Контактная информация">
                    <div className={styles.row}>
                        <span>Телефоны</span>
                        <div>
                            <a href={`tel:${CONTACTS.mobile.replace(/\D/g, '')}`}>{CONTACTS.mobile}</a>
                            <a href={`tel:${CONTACTS.phone.replace(/\D/g, '')}`}>{CONTACTS.phone}</a>
                        </div>
                    </div>

                    <div className={styles.row}>
                        <span>Адрес</span>
                        <strong>{CONTACTS.address}</strong>
                    </div>

                    <div className={styles.row}>
                        <span>Email</span>
                        <a href={`mailto:${CONTACTS.email}`}>{CONTACTS.email}</a>
                    </div>

                    <div className={styles.row}>
                        <span>Соцсети</span>
                        <a className={styles.vkLink} href={CONTACTS.vk} target="_blank" rel="noreferrer">
                            <img className={styles.vkLogo} src={vkLogo} alt="" aria-hidden="true"/>
                            vk.ru/4zveta
                        </a>
                    </div>
                </address>

                <iframe
                    className={styles.map}
                    title="Карта проезда к 4 Цвета"
                    src={CONTACTS.mapUrl}
                    loading="lazy"
                />
            </section>
        </Container>
    );
};

export default Contacts;
